<template>
  <div>
    <canvas id="canvas" ref="canvas" :width="width" :height="height">
    </canvas>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 600
    },
    height: {
      type: Number,
      default: 300
    }
  },
  inject: ['automaton', 'config'],
  computed: {
    cellSize () {
      return this.width / this.automaton.size
    }
  },
  data () {
    return {
      context: null,
    }
  },
  methods: {
    clearCanvas () {
      this.context.clearRect(0,0, this.width, this.height)
      this.context.fillStyle = this.config.deadColor
      this.context.fillRect(0, 0, this.width, this.height)
    },
    drawLine (lattice, y) {
      lattice.forEach((v, i) => {
        this.context.fillStyle = v === 1 ? this.config.aliveColor : this.config.deadColor
        this.context.fillRect(i, y, this.cellSize, this.cellSize)
      })
    },
    shiftCanvas (offset) {
      const imgdata = this.context.getImageData(0, offset, this.width, this.height - offset)
      this.context.putImageData(imgdata, 0, 0)
    },
    toDataURL (type) {
      return this.$refs.canvas.toDataURL(type)
    }
  },
  mounted () {
    this.context = this.$refs.canvas.getContext('2d')
    this.clearCanvas()
    this.automaton.on('updated', ({lattice, age}) => {
      if (age === 0) {
        this.clearCanvas()
      }
      if (age < this.height) {
        this.drawLine(lattice, age)
      } else {
        this.shiftCanvas(this.cellSize)
        this.drawLine(lattice, this.height - 1)
      }
    })
  }
}
</script>
<style>
#canvas {
  border: 2px solid #999;
}
</style>
